import { of, } from 'rxjs';
import { actions, } from '@ezugi/bootstrap';

import { BET_ON_TEEN_PATTI_BET_TYPES, } from '@ezugi/constants';
import { gameResultsSelector, } from '../../selectors/game';

const { PLAYER_A, PLAYER_B, } = BET_ON_TEEN_PATTI_BET_TYPES;

const { gameActions: { game, }, } = actions;

export default function handleWonBets({ WinningBets, }, state) {
  const wonSidebets = Object.entries(WinningBets).reduce(
    (acc, [ betType, value, ]) => ([ PLAYER_A, PLAYER_B, ].includes(betType)
      ? acc
      : [ ...acc, { betType, value, }, ]),
    []
  );

  return of(game.set({
    gameResults: {
      ...gameResultsSelector(state),
      wonSidebets,
      winningBets: WinningBets,
    },
  }));
}
